export default __webpack_public_path__ + "static/7-bd4588a638d26cd57e0da1147ee6a2fb.jpg";